import { Box, Typography, Link, Stack } from "@mui/material";

const Footer = () => (
  <Box
    component="footer"
    sx={{
      py: 3,
      textAlign: "center",
      borderTop: (t) => `1px solid ${t.palette.divider}`,
    }}
  >
    <Stack
      direction="row"
      spacing={2}
      justifyContent="center"
      sx={{ mb: 1, flexWrap: "wrap" }}
    >
      <Link href="https://app.termly.io/policy-viewer/policy.html?policyUUID=601d3739-fe21-4459-9041-29064665c21a">
        Terms & Conditions
      </Link>
      <Link
        href="https://app.termly.io/policy-viewer/policy.html?policyUUID=f0d9df45-29cc-400f-8953-784784ca6669"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </Link>
      {/* <Link href="/contact">Help</Link> */}
    </Stack>

    <Typography variant="body2" sx={{ mb: 0.5 }}>
      © {new Date().getFullYear()} Industrial Automation Supply
    </Typography>
    <Typography variant="caption" color="text.secondary" display="block">
      Operated by WebNova LLC on behalf of Kautex Machines Inc • Payments
      processed securely by Stripe. We do not store card details.
    </Typography>
  </Box>
);

export default Footer;
